export function loadScript(src, { crossorigin } = {}) {
  return new Promise((resolve, reject) => {
    if (!src) return reject(new Error('No script src provided'));
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (crossorigin) s.setAttribute('crossorigin', crossorigin);
    s.onload = () => resolve(s);
    s.onerror = () => reject(new Error(`Failed to load script ${src}`));
    document.head.appendChild(s);
  });
}
